import BigNumber from 'bignumber.js';
import crypto, { HexBase64Latin1Encoding } from 'crypto';
import store from '../store';
import { getBetsFromLocalStorage } from './LocalStorage';

export function round(value: number, precision: number) {
  if (Number.isInteger(precision)) {
    var shift = Math.pow(10, precision);
    // Limited preventing decimal issue
    return Math.round(value * shift + 0.00000000000001) / shift;
  } else {
    return Math.round(value);
  }
}

export function toBTC(sats: number, decimalPlaces?: number) {
  const num = new BigNumber(sats).div(new BigNumber(100000000));
  if (decimalPlaces) return num.toFixed(decimalPlaces);
  return num.toFixed(8).replace(/(\.0+|0+)$/, '');
}

export function getBTCValue(btc: number | string) {
  let _btc: number = typeof btc === 'string' ? parseFloat(btc) : btc;
  return round(_btc * store.getState().prices.btcusd, 2).toFixed(2);
}

export function satsToValue(sats: number, btcPrice: number) {
  return round((sats / 100000000) * btcPrice, 2).toFixed(2);
}

export function toDateString(resolutionDate: Date): any {
  return resolutionDate
    .toString()
    .split(' ')
    .slice(1, 5)
    .concat(resolutionDate.toString().split(' ').slice(6))
    .join(' ');
}

export function formatNumber(num, decimals = true) {
  if (typeof num === 'string') num = parseFloat(num);
  if (isNaN(num)) return '0.00';

  return `${num
    .toFixed(decimals ? 2 : 0)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
  // .replace(/[.,]00$/, '')}`;
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function urlEncode(base64) {
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

export function sha256(str: string): Buffer;
export function sha256(str: string, encoding: HexBase64Latin1Encoding): Buffer;

export function sha256(
  str: string,
  encoding?: HexBase64Latin1Encoding
): Buffer | string {
  const hash = crypto.createHash('sha256').update(str);
  return encoding ? hash.digest(encoding) : hash.digest();
}

export function getFundingUtxos(contracts) {
  const fundingAddresses: any[] = [];
  const fundingUtxos: any[] = [];
  contracts.forEach((contract) => {
    contract[
      contract.isLocalParty ? 'localPartyInputs' : 'remotePartyInputs'
    ].utxos.forEach((utxo) => {
      if (fundingAddresses.indexOf(utxo.address) === -1)
        fundingAddresses.push(utxo.address);
      fundingUtxos.push(utxo);
    });
  });

  return { addresses: fundingAddresses, utxos: fundingUtxos };
}

export async function getUsedUtxos() {
  const contracts = (await getBetsFromLocalStorage()).map(
    (bet) => bet.contract
  );

  return getFundingUtxos(contracts).utxos;
}

export function handle<T>(promise: Promise<T>): Promise<[T?, Error?]> {
  return promise
    .then((data) => [data, undefined] as [T?, Error?])
    .catch((error) => [undefined, error] as [T?, Error?]);
}

export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const popupCenter = ({ url, title, w, h, opts }) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  var _innerOpts = '';
  if (opts !== null && typeof opts === 'object') {
    for (var p in opts) {
      if (opts.hasOwnProperty(p)) {
        _innerOpts += p + '=' + opts[p] + ',';
      }
    }
  }
  // Fixes dual-screen position, Most browsers, Firefox
  var dualScreenLeft =
    // @ts-expect-error
    // eslint-disable-next-line no-restricted-globals
    window.screenLeft !== undefined ? window.screenLeft : screen.left;
  var dualScreenTop =
    // @ts-expect-error
    // eslint-disable-next-line no-restricted-globals
    window.screenTop !== undefined ? window.screenTop : screen.top;

  var width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : // eslint-disable-next-line no-restricted-globals
      screen.width;
  var height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : // eslint-disable-next-line no-restricted-globals
      screen.height;

  var left = width / 2 - w / 2 + dualScreenLeft;
  var top = height / 2 - h / 2 + dualScreenTop;
  var newWindow = window.open(
    url,
    title,
    _innerOpts +
      ' width=' +
      w +
      ', height=' +
      h +
      ', top=' +
      top +
      ', left=' +
      left
  );

  // Puts focus on the newWindow
  // @ts-ignore
  if (window.focus) {
    newWindow?.focus();
  }
};
